import { useContext } from "react";
import { UserInfoContext } from "../Contexts/UserInfoProvider";

const useUserInfo = () => {
    return useContext(UserInfoContext);
}

export default useUserInfo;